import type { CheckboxConfig } from '#types/config/components/vf/checkbox'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    control: {
      size: {
        md: 'mt-0.5',
        sm: 'mt-0.5'
      },
      variant: {
        base: {
          default: 'ring-brand-4',
          selected: 'bg-brand-4 ring-brand-4 c-brand-5'
        },
        inverse: {
          default: 'ring-brand-5',
          selected: 'bg-brand-5 ring-brand-5 c-brand-4'
        }
      }
    },
    label: {
      size: {
        md: 'body-3',
        sm: 'body-4'
      },
      variant: {
        base: {
          default: 'c-black'
        }
      }
    },
    wrapper: {
      size: {
        md: 'gap-x-2'
      }
    }
  },
  iconSize: {
    sm: 'sm',
    md: 'sm'
  },
  radius: {
    sm: '0.0625rem',
    md: '0.0625rem'
  }
} satisfies RecursivePartial<CheckboxConfig>
